<template>
  <div>
    <Frontendlayout>
      <!-- <section class="hero_in hotels hero_single version_2 ">
      <div class="wrapper">
            </div>
      <FilterType1new :loadNearbyOffers="loadNearbyOffers" :search="search" />
    </section> -->
      <section class="hero_in general">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Offer List</h1>
          </div>
        </div>
      </section>

      <div class="filters_listing sticky_horizontal">
        <div class="container">
          <ul class="clearfix">
            <!-- <li>
            <div class="switch-field">
              <input
                type="radio"
                id="all"
                name="listing_filter"
                value="all"
                checked
                data-filter="*"
                class="selected"
              />
              <label for="all">All</label>
              <input
                type="radio"
                id="popular"
                name="listing_filter"
                value="popular"
                data-filter=".popular"
              />
              <label for="popular">Popular</label>
              <input
                type="radio"
                id="latest"
                name="listing_filter"
                value="latest"
                data-filter=".latest"
              />
              <label for="latest">Latest</label>
            </div>
          </li> -->
            <li style="float: right">
              <div class="layout_view">
                <a
                  @click.prevent="changeview('gridview')"
                  :class="gridview == true ? 'active' : ''"
                  ><i class="icon-th"></i
                ></a>
                <a
                  href="#0"
                  :class="listview == true ? 'active' : ''"
                  @click.prevent="changeview('listview')"
                  ><i class="icon-th-list"></i
                ></a>
              </div>
            </li>
            <!-- <li>
            <a href="#" @click="resetFilter()"
              ><span class="badge badge-info">Clear Filter</span></a
            >
          </li> -->
            <!-- <li>
            <a
              class="btn_map"
              data-toggle="collapse"
              href="#collapseMap"
              aria-expanded="false"
              aria-controls="collapseMap"
              data-text-swap="Hide map"
              data-text-original="View on map"
              >View on map</a
            >
          </li> -->
          </ul>
        </div>
        <!-- /container -->
      </div>
      <!-- /filters -->

      <div class="collapse" id="collapseMap">
        <div id="map" class="map"></div>
      </div>
      <!-- End Map -->
      <div class="container margin_60_35">
        <div class="row">
          <div class="col-md-12 mb-5">
            <VueSlickCarousel v-if="banners.length > 0" v-bind="settings">
              <div v-for="banner in banners" :key="banner">
                <img
                  :src="`https://peekzy.in/backend/public/assets/user/vendorbanner/${banner.banner_image}`"
                  style="width: 100%"
                  height="150px"
                />
              </div>
            </VueSlickCarousel>
          </div>
          <aside class="col-lg-3" id="sidebar">
            <LeftFilter1
              :loadNearbyOffers="loadNearbyOffers"
              :search="search"
              :catList="catOptions"
              :subCatList="subCatOptions"
            />
          </aside>

          <!-- /aside -->

          <div class="col-lg-9" id="list_sidebar">
            <div class="" style="height: 20px" v-show="loader">
              <div class="row">
                <div class="col-lg-12">
                  <center>
                    <h3>{{ loadingText }}</h3>
                  </center>
                </div>
                <div class="col-lg-12">
                  <div data-loader="circle-side"></div>
                </div>
              </div>
            </div>
            <div class="isotope-wrapper">
              <Listoffer :offerList="offerList" v-show="listview" />
              <ListGridOffer :offerList="offerList" v-show="gridview" />
            </div>
            <!-- /isotope-wrapper -->

            <!-- <p class="text-center add_top_30">
            <a href="#0" class="btn_1 rounded">Load more</a>
          </p> -->
          </div>
          <!-- /col -->
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->

      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import { EventBus } from "@/EventBus";
// import FilterType1new from "@/cmps/FilterType1new.vue";
import LeftFilter1 from "@/cmps/LeftFilter1new.vue";
import Listoffer from "@/cmps/Listoffer.vue";
import ListGridOffer from "@/cmps/Listgridoffer.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  props: {
    search: {
      type: Object,
      default: () => {
        return {
          pincode: "",
          location: "",
          categories: [],
          subcategories: [],
          mindiscount: "",
          maxdiscount: "",
          discount_type: "",
            range:0,
        geocodes:[]

        };
      },
    },
  },
  created() {
    EventBus.$on("emittedData", (data) => {
      console.log("filter pincode:" + data.search.pincode);
      this.catOptions = data.catList;
      this.subCatOptions = data.subCatList;
    });
  },
  data() {
    return {
      offerList: [],
      listview: true,
      gridview: false,
      // search: {
      //   pincode: "400101",
      //   location: "Mumbai, Maharashtra",
      //   categories: [],
      //   subcategories: [],
      // },
      settings: {
        arrows: false,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        fade: true,
        slidesToScroll: 1,
        autoplay: true,
        speed: 3000,
        autoplaySpeed: 3000,
        cssEase: "linear",
      },
      catOptions: [],
      subCatOptions: [],
      banners: [],
    };
  },
  beforeMount() {
    //alert("hii");
    this.loadNearbyOffers("all");
    this.bannerAds();
    this.getbanner();
  },

  components: {
    LeftFilter1,
    Listoffer,
    ListGridOffer,
    VueSlickCarousel,
    // FilterType1new,
    Frontendlayout,
  },
  methods: {
    changeview(view) {
      if (view == "listview") {
        this.listview = true;
        this.gridview = false;
      } else {
        this.listview = false;
        this.gridview = true;
      }
    },
    getbanner() {
      const token = localStorage.getItem("token");
      API.get(`https://peekzy.in/backend/public/Banner/getbanner`, {
        headers: { Authorization: token },
      })
        .then((res) => {
          this.banners = res.data;
        })
        .catch((err) => {
          this.toast.error(err.message);
        });
    },
    resetFilter() {
      this.search = {
        pincode: "",
        location: "",
        categories: [],
        subcategories: [],
        mindiscount: "",
        maxdiscount: "",
        discount_type: "",
      };
    },
    bannerAds() {
      // API({
      //   method: "post",
      //   url: "/search/offerlist",
      //   data: form,
      //   auth: {
      //     username: "testclient",
      //     password: "testsecret",
      //   },
      // }).then((res) => {
      //   this.loader = false;
      //   this.loading = false;
      //   if (res.data.status == 200) {
      //     this.offerList = res.data.data;
      //     //this.$swal("Success", res.data.messages);
      //   } else {
      //     this.$swal("Error", res.data.messages);
      //   }
      // });
    },
    loadNearbyOffers(filter) {
      console.log("subcategories:" + this.search.subcategories);
      this.loader = true;
      this.loadingText = "Please wait while we load result for you";
      const form = new FormData();
      //alert($(".childcat").is(":checked").val());
      //if (filter != "all")
      console.log(filter);
      form.append("search", JSON.stringify(this.search));

      API({
        method: "post",
        url: "/search/offerlist",
        data: form,
        auth: {
          username: "testclient",
          password: "testsecret",
        },
      }).then((res) => {
        this.loader = false;
        this.loading = false;
        if (res.data.status == 200) {
          this.offerList = res.data.data;
          //this.$swal("Success", res.data.messages);
        } else {
          this.$swal("Error", res.data.messages);
        }
      });
    },
  },
};
</script>


<style  scoped>
/*@import "../../public/frontend/css/custom.css";*/
a {
  color: #fc5b62 !important;
}
</style>